(() => {
  const selector = 'a[href], button, input, select, textarea, summary, iframe, [contenteditable="true"], [tabindex]';
  const update = container => {
    const hidden = container.getAttribute('aria-hidden') === 'true';
    container.querySelectorAll(selector).forEach(element => {
      if (hidden) {
        if (!element.hasAttribute('data-a11y-tabindex')) {
          element.setAttribute('data-a11y-tabindex', element.getAttribute('tabindex') || '');
        }
        element.setAttribute('tabindex', '-1');
      } else if (element.hasAttribute('data-a11y-tabindex')) {
        const previous = element.getAttribute('data-a11y-tabindex');
        if (previous) element.setAttribute('tabindex', previous);
        else element.removeAttribute('tabindex');
        element.removeAttribute('data-a11y-tabindex');
      }
    });
  };
  const scan = root => {
    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) return;
    if (root.matches && root.matches('[aria-hidden]')) update(root);
    root.querySelectorAll('[aria-hidden]').forEach(update);
  };
  scan(document);
  new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === 'attributes') update(mutation.target);
      mutation.addedNodes.forEach(scan);
    });
  }).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-hidden'] });
})();
